import type { ComposedForm } from 'lib-node-question-builder';

import Box from '~/common/mui/Layout/Box';

import type { AddressInfoData } from '../../../types';

type ResidencyHistoryPrimaryAlertProps = {
  form: ComposedForm<AddressInfoData['formData']>;
};

function getPrimaryAlertState(s: { values?: AddressInfoData['formData'] }) {
  const primaryResidences =
    s.values?.residenceHistoryDetails?.borrowerResidenceHistory?.filter(
      ({ borrowerAddress }) => borrowerAddress?.primaryResidence === true,
    );

  const primaryCount =
    (s.values?.residenceHistoryDetails?.primaryResidence ? 1 : 0) +
    (primaryResidences?.length ?? 0);

  return {
    showAtleastOnePrimaryAlert: primaryCount === 0,
    showOnlyOnePrimaryAlert: primaryCount > 1,
  };
}

export function ResidencyHistoryPrimaryAlerts({
  form,
}: Readonly<ResidencyHistoryPrimaryAlertProps>) {
  return (
    <Box sx={{ marginX: '0.5rem' }}>
      <form.Subscribe selector={getPrimaryAlertState}>
        {({ showAtleastOnePrimaryAlert, showOnlyOnePrimaryAlert }) => (
          <>
            {showAtleastOnePrimaryAlert ? (
              <form.Alert
                name="showAtleastOnePrimaryAlert"
                severity="redStop"
                style={{ marginBottom: '1rem' }}
                message="Borrower must have at least one primary address associated with this borrower."
              />
            ) : null}
            {showOnlyOnePrimaryAlert ? (
              <form.Alert
                name="showOnlyOnePrimaryAlert"
                severity="redStop"
                style={{ marginBottom: '1rem' }}
                message="Only one primary address is allowed."
              />
            ) : null}
          </>
        )}
      </form.Subscribe>
    </Box>
  );
}
